import React, { useState } from 'react'
import { CloseEyeIcon, EyeIcon, GiftIcon, LockIcon, SettingIcon, UserIcon, WebsiteLogo } from '../helper/Icons'
import { Link } from 'react-router-dom'
import MobileSidebar from './MobileSidebar';
import { languages } from '../helper/Helper';

function Header() {
    const [menu, setMenu] = useState(false);
    const [showPassword, setShowPassword] = useState(false);
    const [showLangDropdown, setShowLangDropdown] = useState(false);
    const [selectedLang, setSelectedLang] = useState('en');

    function togglePass() {
        setShowPassword(preShowPassword => !preShowPassword)
    }

    function toggleMenu() {
        setMenu(prevMenu => !prevMenu);
        menu === true ? document.body.classList.remove('overflow-y-hidden') : document.body.classList.add('overflow-y-hidden');
    }

    function toggleLangDropdown() {
        setShowLangDropdown(prev => !prev);
    }

    function selectLanguage(langCode) {
        setSelectedLang(langCode);
    }

    const getCurrentLanguageIcon = () => {
        const currentLang = languages.find(lang => lang.code === selectedLang);
        return currentLang?.icon || languages[0].icon;
    };

    return (
        <>
            <header className='bg-black'>
                <div className="wrapper mx-auto">
                    <nav className="navbar navbar-expand-lg py-2 py-lg-3" data-bs-theme="dark">
                        <div className="container-fluid px-0">
                            <div className="logo">
                                <Link to="#" className="navbar-brand me-lg-4"><WebsiteLogo /></Link>
                            </div>
                            <button onClick={toggleMenu} className="navbar-toggler p-1 shadow-none" type="button" data-bs-toggle="collapse" data-bs-target="#navbarSupportedContent" aria-controls="navbarSupportedContent" aria-expanded="false" aria-label="Toggle navigation">
                                <span className="navbar-toggler-icon"></span>
                            </button>
                            <div className="collapse navbar-collapse ms-2 justify-content-end" id="navbarSupportedContent">
                                <form className='d-flex gap-3 gap-xl-4'>
                                    <div className="navbar-nav mb-2 mb-lg-0">
                                        <div className='d-flex gap-3'>
                                            <div className='bg-cinder d-flex align-items-center gap-2 max-w-180 border-ebonyclay rounded-3 px-3 py-2'>
                                                <span className='w-100 max-w-15'><UserIcon /></span>
                                                <input type="text" id='username' placeholder='Username' required className='bg-transparent border-0 outline-none w-100 text-marbleblue fs-14' autoComplete="off" />
                                            </div>
                                            <div className='bg-cinder d-flex align-items-center gap-2 max-w-190 border-ebonyclay rounded-3 px-3 pe-2 py-2'>
                                                <span className='w-100 max-w-15'><LockIcon /></span>
                                                <input type={showPassword === true ? 'text' : 'password'} id='password' placeholder='Password' required className='bg-transparent border-0 outline-none w-100 text-marbleblue fs-14' autoComplete="off" />
                                                <span className='w-100 max-w-20 cursor-pointer' onClick={togglePass}>
                                                    {showPassword === true ? <CloseEyeIcon /> : <EyeIcon />}
                                                </span>
                                            </div>
                                        </div>
                                    </div>
                                    <div className='d-flex align-items-center gap-2'>
                                        <div className='d-flex align-items-center gap-3'>
                                            <button type='submit' className='login border-0 ease-in-out3ms montserrat text-white fw-semibold leading-120 text-decoration-none bg-darkslategrey rounded-3 px-3 py-2'>Log in</button>
                                            <Link to={'/'} className='ms-1 montserrat text-white fw-semibold leading-120 text-decoration-none ease-in-out3ms rounded-3 position-relative bg-cherrygradient hover-bg-cherrygradient px-3 py-2'>Sign Up <span className='position-absolute bottom-0'><GiftIcon /></span></Link>
                                        </div>
                                        <div className='bg-darkslategrey d-flex align-items-center rounded-3 ms-4 p-2'>
                                            <div className='border-riverbed border-0 border-end pe-2 position-relative'>
                                                <div className='d-flex align-items-center'>
                                                    {getCurrentLanguageIcon()}
                                                </div>
                                            </div>
                                            <div className='cursor-pointer ps-2' onClick={toggleLangDropdown}>
                                                <SettingIcon />
                                                {showLangDropdown && (
                                                    <div className='min-w-150 position-absolute top-100 end-0 bg-darkslategrey rounded-3 py-1 shadow-lg z-3'>
                                                        {languages.map((lang) => (
                                                            <div
                                                                key={lang.code}
                                                                className={`px-3 py-2 cursor-pointer hover:bg-cinder ${selectedLang === lang.code ? 'bg-cinder' : ''}`}
                                                                onClick={() => selectLanguage(lang.code)}
                                                            >
                                                                <div className='d-flex align-items-center gap-2'>
                                                                    {lang.icon}
                                                                    <span className='text-white fs-14'>{lang.name}</span>
                                                                </div>
                                                            </div>
                                                        ))}
                                                    </div>
                                                )}
                                            </div>
                                        </div>
                                    </div>
                                </form>
                            </div>
                        </div>
                    </nav>
                </div>
            </header>
            <MobileSidebar menu={menu} toggleMenu={toggleMenu} showPassword={showPassword} togglePass={togglePass} toggleLangDropdown={toggleLangDropdown} getCurrentLanguageIcon={getCurrentLanguageIcon} showLangDropdown={showLangDropdown} selectedLang={selectedLang} selectLanguage={selectLanguage} />
        </>
    )
}

export default Header